import React, { useEffect, useContext, useState, useMemo } from 'react';
import { connect, useSelector } from 'react-redux';
import { withNamespaces } from 'react-i18next';
import { createStructuredSelector } from 'reselect';
import queryString from 'query-string';
import { cloneDeep, isEqual, isEmpty, get } from 'lodash';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { isExperienceEditorActive } from '@sitecore-jss/sitecore-jss';
import { Scrollbars } from 'react-custom-scrollbars-2';
import moment from 'moment';
import {
  getFiltersInfoData,
  getFiltersInfoSuccess,
  updateFiltersData,
  updateSelectedFiltersData,
  updateQueryFilterData,
  getFilterdInfoData,
  clearFilterData,
  mobileFiltersUpdate,
  clearFilteredData,
  updateMultipleFiltersData,
  clearAllClicked,
  updateFiltersForAdCalendarData,
  shouldResetFiltersForAdCalendarData,
  getFilterdInfoSuccess
} from './redux/actions';
import {
  filtersData,
  selectedFiltersData,
  clearAllClickedData,
} from './redux/selectors';
import CheckBoxMUI from '../../../components/atoms/Forms/CheckBox';
import useStyles from './style';
import { Box, Hidden, SwipeableDrawer, useMediaQuery } from '@material-ui/core';
import ButtonMUI from '../../../components/atoms/Button';
import DctSvgIcon from '../../../components/atoms/Svg';
import { canUseDOM } from '../../../utils/canUseDOM';
import SelectMUI from '../../../components/atoms/Forms/Select';
import RadioMUI from '../../../components/atoms/Forms/Radio';
import Calender from '../../../components/atoms/Forms/Calendar';
import Grid from '../../../components/molecules/Grid';
import { analyticsData } from '../../../../../src/constants/Analytics/analytics-data';
import {
  pushAnaylyticsData,
  createDynamicLabels,
} from '../../../../../src/utils/analytics';
import Typography from '../../../components/atoms/Typography';
import CustomLink from '../../../components/atoms/Link';
import {
  checkboxType,
  dictionaryKeys,
  dropdownType,
  calendarType,
  dateRangeKeys,
  priceTaxonomyKey,
  regionTaxonomyKey,
  tripadvisorratingTaxonomyKey,
  FILTERS_TO_AVOID_IN_AD_CALENDAR
} from './constants';
import {
  isFilterObjectEmpty,
  extractFiltersFromFiltersData,
  getFilterCount,
  getHelperKeysFromDictionary,
  removeEmpty,
  updateFilterData,
  isFilterObjectEmptyWithoutGTMValues,
  getQueryFromURL
} from '../../../../utils/utility';
import withErrorBoundary from '../../../utils/HOCs/withErrorBoundary';
import clsx from 'clsx';
import { FILTER_LIST_MOBILE_SECTION, FILTER_CONTAINER } from './locators';
import { searchTermData } from '../GlobalSearchSubLayout/redux/selectors';
import {
  getComponentName,
  getPageName,
} from '../../../utils/getPageComponentInfo';
import {
  EVENT_TYPE,
  ATTRIBUTE_TYPE,
  TAG_TEXT,
} from '../../../../constants/index';
import { getDictionaryText } from '../../../utils/getDictionaryText';
import { getLocalStorage } from './../../../../utils/localStorage';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import FavoriteContext from './../../../../context/favorite/FavoriteContext';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Paper, MenuList, ListItemText } from '@material-ui/core';
import { getStartAndEndDate } from '../../../../utils/utility';
import ADListing from '../../../components/organism/ADListing/ADListing';
import StickyBar from '../../../components/atoms/StickyBar';/*
 *  This mapes atoms to filter fields
 */
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useRef } from 'react';
import { getApiPayload, toggleTargetFilters, getDaysPeriod, getSelectedFiltersForPayload, displayFeatureSection, toggleDisplayOfFeaturedSection, handleUpdateQueryParamsForFilter, excludeGTMTags, splitingNonRemoveableFilters, isGTMTagsInURL } from './helpers';

const mapper = {
  checkbox: CheckBoxMUI,
  dropdown: SelectMUI,
  radio: RadioMUI,
  calendar: Calender,
};

/*
 *  This function returns payload for solr API call for different cases on different pages
 */
const getSolrPayloadForFilters = (
  filters,
  shouldFetchFilterDetails,
  contentType,
  isGlobalSearchTemplate,
  searchTerm,
  language,
  category,
  filtersData,
  isEditor,
  attributeListingTag,
  props
) => {
  const { parentComponentName } = props;

  try {
    let solrPayloadToFetchFilter = {};

    let shouldCallAPI = true;

    // In case of global search page search term is sent to API
    if (contentType == '' && parentComponentName === 'FavoriteSubLayout') {
      contentType = 'favorites';
    }
    if (!isGlobalSearchTemplate) {
      solrPayloadToFetchFilter.contentType = contentType;
    } else {
      solrPayloadToFetchFilter.searchTerm = searchTerm;
    }
    let favData = JSON.parse(getLocalStorage('favorites') || '[]');

    solrPayloadToFetchFilter.language = language;
    solrPayloadToFetchFilter.facetFields = [];
    if (parentComponentName === 'FavoriteSubLayout') {
      solrPayloadToFetchFilter.itemIDs = favData;
    }
    //For attribute listing page initial card limits are driven by sitecore,
    solrPayloadToFetchFilter.limit =
      contentType === ATTRIBUTE_TYPE
        ? Number(getDictionaryText('attributePageLoadCount'))
        : 9;
    solrPayloadToFetchFilter.offset = 0;
    solrPayloadToFetchFilter.filters = [];
    solrPayloadToFetchFilter.isPreviewMode = isEditor;
    if (category) {
      solrPayloadToFetchFilter.filters.push({
        key: get(category, 'taxonomyKey.value', ''),
        value: get(category, 'searchKey.value', ''),
      });
    }

    if (shouldFetchFilterDetails) {
      filters &&
        filters.forEach(filter => {
          if (get(filter, 'fields.taxonomyKey')) {
            solrPayloadToFetchFilter.facetFields.push(
              filter.fields.taxonomyKey.value
            );
          }
        });
      const searchString = queryString.parse(
        window && window.location && window.location.search,
        { arrayFormat: 'comma' }
      );
      contentType === ATTRIBUTE_TYPE &&
        solrPayloadToFetchFilter.filters.push({
          key: TAG_TEXT,
          value: (searchString && searchString.tag) || '',
        });
    } else {
      if (!isEmpty(filters)) {
        if (!isGlobalSearchTemplate) {
          solrPayloadToFetchFilter.sortingOrder = {
            order: 'asc',
            sortBy: 'name',
          };
        }
        if (filters.startDate) {
          if (filters.endDate) {
            solrPayloadToFetchFilter.dateRange = {
              startDateField: dateRangeKeys.startDateAPIKey,
              startDate: filters.startDate,
              endDateField: dateRangeKeys.endDateAPIKey,
              endDate: filters.endDate,
            };
          } else {
            shouldCallAPI = false;
          }
        }
        Object.keys(filters).forEach(key => {
          if (
            !(key === dateRangeKeys.startDate || key === dateRangeKeys.endDate)
          ) {
            if (Array.isArray(filters[key]) && filters[key].length > 0) {
              filters[key].forEach(filter => {
                let data = {
                  key: key,
                  value: '',
                };
                data.value = filter;
                solrPayloadToFetchFilter.filters.push(data);
              });
            } else if (!Array.isArray(filters[key]) && filters[key]) {
              if (key === regionTaxonomyKey) {
                let data = {
                  key: key,
                  value: filters[key],
                };
                solrPayloadToFetchFilter.filters.push(data);
              } else {
                let data = {
                  key: key,
                  value: filters[key],
                };
                solrPayloadToFetchFilter.filters.push(data);
              }
            }
          }
        });
      }
      contentType === ATTRIBUTE_TYPE &&
        solrPayloadToFetchFilter.filters.push({
          key: TAG_TEXT,
          value: attributeListingTag,
        });
    }
    if (shouldCallAPI) {
      return solrPayloadToFetchFilter;
    } else {
      return false;
    }
  } catch (err) {
    console.error('Error while setting payload data', err);
  }
};

/*
 *  This function returns equality of two states based on the values selected in them by user
 */
const isStateEqual = (dummy, original) => {
  let isEqual = true;
  if (dummy.length === original.length) {
    for (let key in dummy) {
      if (JSON.stringify(dummy[key]) !== JSON.stringify(original[key])) {
        isEqual = false;
      }
    }
  } else {
    isEqual = false;
  }

  return isEqual;
};

const Filters = props => {
  const classes = useStyles();
  const { shouldResetFilter } = useSelector(state => state.FilteredDataReducer);
  const { filterCount } = useSelector(state => state.SelectedFiltersReducer);
  const { eventCounts } = useSelector(state => state.FiltersReducer);

  const [attributeListingTag, setAttributeListing] = React.useState('');
  const [shouldOpenDrawer, setShouldOpenDrawer] = React.useState(false);
  const [shouldCheckURL, setShouldCheckURL] = React.useState(true);
  const [shouldUpdateDummyState, setShouldUpdateDummyState] = React.useState(
    true
  );
  const [dummyFiltersData, setDummyFiltersData] = React.useState([]);
  const [dummyFiltersLength, setDummyFiltersLength] = React.useState(0);
  const [isFirstLoad, setIsFirstLoad] = React.useState(true);
  const [stateSearchTerm, setStateSearchTerm] = React.useState('');
  const [adEventTabs, setAdEventTabs] = useState(null);
  const [adCalendarFiltersDesktop, setAdCalendarFiltersDesktop] = useState([])
  const [stopHitsOnFilters, setStopHitsOnFilters] = useState(false)
  // Event Layout States  Starts //
  const [editMenu, setEditMenu] = useState(false);
  const [filterAdCalendarByDays, setFilterAdCalendarByDays] = useState({ params: {}, startDate: null, endDate: null, calendar: { startDate: null, endDate: null } });
  const [adCalendarTopBannerInitialValue, setAdCalendarTopBannerInitialValue] = useState(null)
  const isMobile = useMediaQuery('(max-width:1023px)');
  const pageName = getPageName(props);
  const componentName = getComponentName(props);
  const { appConfig: apiUrl, parentComponentName } = props;
  const { favorites } = useContext(FavoriteContext);
  const adCalendarItems = get(props, 'sitecoreContext.route.fields.EventInterestFilterlist', []);
  let bannerWithEventFilter = {}
  if (props.params.isEventListPage) {
    bannerWithEventFilter = get(props, 'sitecoreContext.route.placeholders.vad-main', [])
    bannerWithEventFilter = bannerWithEventFilter.find(item => item.componentName === 'BannerWithEventFilterSubLayout')
  }
  const prevScrollVal = useRef(0);
  let isEditor;
  const isADeventFilters = get(props, 'params.isEventListPage', false);
  const previewMode =
    props &&
    props.sitecoreContext &&
    props.sitecoreContext.pageState &&
    props.sitecoreContext.pageState.toLowerCase();

  if (isExperienceEditorActive() || previewMode === 'preview') {
    isEditor = true;
  } else {
    isEditor = false;
  }

  const resetAdCalendarSelections = () => {
    props.clearAllClicked(true);
    const selectedFilters = extractFiltersFromFiltersData(filtersData);
    handleUpdateQueryParamsForFilter({ selectedFilters, isGlobalSearchTemplate, searchTerm })
    displayFeatureSection('ResetSelectedFilters', { adEventTabs, filterAdCalendarByDays })
    const filters = getSelectedFiltersForPayload({ filtersData })
    const payload = getApiPayload({ filterAdCalendarByDays, filters, adEventTabs })
    fetchFiltersResultApi(payload)
  }

  const periodFilters = useMemo(() => {
    return isADeventFilters && bannerWithEventFilter && bannerWithEventFilter.fields.date.map(o => o.fields.taxonomyKey.value) || []
  }, [bannerWithEventFilter])

  const updateURLOnClearAllFilters = () => {
    if (canUseDOM) {
      const searchString = window.location.search
      const excludedGTMUrls = splitingNonRemoveableFilters()
      const preservedQuery = Array.from(new URLSearchParams(searchString).entries())
        .filter(([key]) => excludedGTMUrls.has(key))
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join("&");

      const newUrl = preservedQuery
        ? `${window.location.origin}${window.location.pathname}?${preservedQuery}`
        : `${window.location.origin}${window.location.pathname}`;

      window.history.replaceState({}, document.title, newUrl);
    }
  }

  useEffect(() => {
    if (shouldResetFilter && isADeventFilters) {
      setFilterAdCalendarByDays({ params: {}, startDate: null, endDate: null, calendar: { startDate: null, endDate: null } })
      setAdEventTabs(null)
      props.clearFilterData();
      props.clearAllClicked(true);
      props.shouldResetFiltersForAdCalendarData(false)
      if (isMobile) onCloseClickMobile()
      updateURLOnClearAllFilters()
      toggleDisplayOfFeaturedSection({ filtersData, forceRemove: true })
      const facetFields = props.fields.filters.map((o) => o.fields.taxonomyKey.value)
      fetchFiltersResultApi({ facetFields })
    }
  }, [shouldResetFilter, isADeventFilters])

  // Commented Due to Phase 2 //
  // const [isScrolled, setIsScrolled] = useState(false);

  // const handleScroll = () => {
  //   if (window.scrollY > 200) {
  //     setIsScrolled(true);
  //   } else {
  //     setIsScrolled(false);
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener('scroll', handleScroll);

  //   // Clean up the event listener on component unmount
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  /**
   * Mobile Filters/Interests Sticky Bar
  */
  const [showInterestsMobDrawer, setShowMobInterestsDrawer] = useState(false);
  const [showFilterStickybar, setShowFilterStickybar] = useState(false);
  const [isHeaderVisible, setIsHeaderVisible] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const handleScroll = () => {
    const filterWrapper = document.querySelector('.js-filter_wrapper')
    const isScrollingDown = () => window.scrollY > prevScrollVal.current

    // Create a new instance of MutationObserver
    if (isScrollingDown()) {
      setIsHeaderVisible(false);
    } else {
      setIsHeaderVisible(true);
    }

    prevScrollVal.current = window.scrollY;
    if (filterWrapper && window.scrollY > filterWrapper.clientHeight + 20) {
      setShowFilterStickybar(true);
    } else {
      setShowFilterStickybar(false);
    }

    prevScrollVal.current = window.scrollY;
  };

  function closeInterestsDrawer() {
    setShowMobInterestsDrawer(false)
    document.body.classList.remove('scrollControl')
  }

  useEffect(() => {
    const interestMobDrawer = document.querySelector('.js-interestsMobDrawer')
    const interesetCategoriesDrawer = document.querySelector('.js-interest_categories')

    if (interestMobDrawer) {
      interestMobDrawer.addEventListener('click', (e) => {
        const clientY = e.clientY;

        if (clientY > interesetCategoriesDrawer.clientHeight + interesetCategoriesDrawer.offsetTop) {
          closeInterestsDrawer()
        }
      })
    }
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showFilterStickybar, isHeaderVisible, showInterestsMobDrawer]);

  function getStickyFiltersForMob(initalValue) {
    if (initalValue) {
      const intialValues = initalValue.value || []
      const found = adCalendarItems.find(({ fields }) => (fields.SearchKey.value === intialValues.join(',')) || (fields.SearchKey.value === intialValues.reverse().join(',')))
      if (found) setSelectedEvent(found)
    }
  }

  const generateJsonForGTM = (searchString, tags) => {
    if (!tags.length) return []
    return tags.map(tag => (
      {
        "fieldLabel": {
          "value": "UTM"
        },
        "totalResultCount": 0,
        "fieldName": {
          "value": tag
        },
        "listItems": [
          {
            "fields": {
              "displayText": {
                "value": tag
              },
              "key": {
                "value": searchString[tag]
              },
              "selected": {
                "value": ""
              },
              "count": {
                "value": 0
              }
            }
          },
        ],
        "selectedValue": {
          "value": searchString[tag]
        },
        "type": "gtm"
      }
    ))
  }

  // Fetch inital filters data from solr API
  useEffect(() => {
    if ((!isGlobalSearchTemplate && language && contentType) || (!isGlobalSearchTemplate && language && parentComponentName === 'FavoriteSubLayout')) {

      if (isSolrResponseForFiltersAvailable) {
        const filtersData = updateFilterData(solRresponse, filters, dictionary);
        if (filtersData) {
          props.getFiltersInfoSuccess({ results: filtersData, apiResult: solRresponse });
        }
      } else {
        const searchString = queryString.parse(
          window && window.location && window.location.search,
          { arrayFormat: 'comma' }
        );
        const isGTMTagInSearch = isGTMTagsInURL(searchString)
        if (isGTMTagInSearch) setStopHitsOnFilters(true)
        else displayFeatureSection('forceHide')
        const extraEventCategoriesToAddInFilters = []
        if (isADeventFilters) {
          adCalendarItems.forEach(({ fields }) => {
            if (!isEmpty(fields.SearchKey.value)) {
              const item = fields.SearchKey.value.split(',') || []
              if (item.length > 0) item.map(o => extraEventCategoriesToAddInFilters.push(o))
            }
          })
          if (searchString.period) setAdEventTabs(periodFilters.findIndex(o => o === searchString.period))
          const periodDays = searchString.period && getStartAndEndDate(searchString.period) || null
          setFilterAdCalendarByDays(prevState => ({ ...prevState, ...(searchString['eventcategories'] && { params: { key: 'eventcategories', value: searchString['eventcategories'] } }), ...(periodDays && { startDate: periodDays.startDate, endDate: periodDays.endDate }), ...(searchString['startDate'] && searchString['endDate'] && { calendar: { startDate: new Date(searchString['startDate']), endDate: new Date(searchString['endDate']) } }) }));
          const initalFilters = searchString['eventcategories'] ? {
            key: 'eventcategories', value: Array.isArray(searchString['eventcategories']) ? searchString['eventcategories']
              : [searchString['eventcategories']]
          } : null
          setAdCalendarTopBannerInitialValue(initalFilters)
          getStickyFiltersForMob(initalFilters)
        }
        const validGtmTags = getDictionaryText('nonremoveablefilters')?.split(',') || []
        const gtmTags = Object.keys(searchString).length && Object.keys(searchString).filter(o => validGtmTags.includes(o)) || [];
        const generateGTMJson = gtmTags.length > 0 && generateJsonForGTM(searchString, gtmTags) || []
        const payload = getSolrPayloadForFilters(
          filters,
          true,
          contentType,
          isGlobalSearchTemplate,
          searchTerm,
          language,
          category,
          [],
          isEditor,
          attributeListingTag,
          props
        );
        var SolrFilterAPIURL = apiUrl.SOLR_FILTERS_DATA;
        if (parentComponentName === 'FavoriteSubLayout') {
          SolrFilterAPIURL = apiUrl.SOLR_FAVORITE_SEARCH_API
        }
        if (payload) {
          props.getFiltersInfoData({
            url: `${isGlobalSearchTemplate
              ? apiUrl.SOLR_SEARCH_API
              : SolrFilterAPIURL
              }`,
            payload: { ...payload, isADeventFilters },
            sitecoreFilters: filters,
            dictionary: props.t,
            ...(!!gtmTags.length && { gtmtags: generateGTMJson }),
            ...(isADeventFilters && { period: getDaysPeriod() }),
            ...(extraEventCategoriesToAddInFilters.length > 0 && { extraEventCategoriesToAddInFilters })
          });
        }
      }
    }
  }, [get(props, 'sitecoreContext.language', '')]);

  const { filters, priceRangeHelpText, title, results: solRresponse } = props.fields;
  const { searchTermData, clearAllClickedData } = props;
  const dictionary = props && props.t;
  const language = get(props, 'sitecoreContext.language', '');
  const isSolrResponseForFiltersAvailable = solRresponse && solRresponse.facetResult && Object.keys(solRresponse.facetResult).length > 0;
  const contentType = get(
    props,
    'sitecoreContext.route.fields.contentType.fields.taxonomyKey.value',
    ''
  ).toLowerCase();

  const category = get(
    props,
    'sitecoreContext.route.fields.category.fields',
    ''
  );
  const templateName = get(props, 'sitecoreContext.route.templateName', '');
  // this key is used to handle global search cases
  const isGlobalSearchTemplate = templateName === 'GlobalSearchResult';

  // Reading keys from dictionary
  const helperKeys = getHelperKeysFromDictionary(dictionary, dictionaryKeys);
  const {
    clearAllText,
    seeLessText,
    seeMoreText,
    applyText,
    resetText,
    selectedFilterText,
    filtersText,
    resetAllText,
  } = helperKeys;

  // this section calls filter API when user changes the search term on global search results page
  if (searchTermData && stateSearchTerm !== searchTermData.data) {
    const searchTerm = searchTermData.data;
    const payload = getSolrPayloadForFilters(
      filters,
      true,
      contentType,
      isGlobalSearchTemplate,
      searchTerm,
      language,
      category,
      [],
      isEditor,
      attributeListingTag,
      props
    );
    var SolrFilterAPIURL = apiUrl.SOLR_FILTERS_DATA;
    if (parentComponentName === 'FavoriteSubLayout') {
      SolrFilterAPIURL = apiUrl.SOLR_FAVORITE_SEARCH_API
    }

    if (payload) {
      props.getFiltersInfoData({
        url: `${isGlobalSearchTemplate
          ? apiUrl.SOLR_SEARCH_API
          : SolrFilterAPIURL
          }`,
        payload: payload,
        sitecoreFilters: filters,
        dictionary: props.t,
      });
    }
    setStateSearchTerm(searchTermData.data);
  }
  const addAnalyticsInfo = (target, isMobile = false) => {
    let analyticsCapturedData;
    if (isMobile) {
      analyticsCapturedData = {
        ...analyticsData.pageBodyInteraction.filterMobileBtnClick,
      };
    } else {
      analyticsCapturedData = {
        ...analyticsData.pageBodyInteraction.filterBtnClick,
      };
    }
    if (target.name !== dateRangeKeys.startDate && target.value) {
      const obj = {
        ...analyticsCapturedData,
        ...{ label: target.value },
      };
      if (target.checked !== undefined) {
        obj.label = `${target.checked
          ? analyticsData.dataLinksText.checkedText
          : analyticsData.dataLinksText.uncheckedText
          } - ${obj.label}`;
      } else if (target.name === dateRangeKeys.endDate) {
        let startDate = '';
        filtersData.forEach(item => {
          if (item.type === calendarType) {
            startDate = item.startDate;
          }
        });
        obj.label = `Start_Date - ${moment(startDate.value).format(
          'DD/MM/YYYY'
        )} && End_Date - ${moment(target.value).format('DD/MM/YYYY')}`;
      }
      obj.label = createDynamicLabels([pageName, componentName, obj.label]);
      pushAnaylyticsData(obj);
    }
  };
  // Extracting search term from URL which is used in case user is on global search page
  let searchTerm = '';
  if (canUseDOM) {
    const searchString = queryString.parse(
      window && window.location && window.location.search,
      { arrayFormat: 'comma' }
    );
    if (
      Object.keys(searchString).length !== 0 &&
      searchString &&
      searchString.searchTerm
    ) {
      searchTerm = searchString.searchTerm;
    }
  }
  // removing animation class from parent node in case of mobile
  if (isMobile && canUseDOM) {
    const filterSection = document.querySelector(
      `[data-locator='${FILTER_CONTAINER}']`
    );
    if (
      filterSection &&
      filterSection.parentNode &&
      filterSection.parentNode.classList.contains('sectionSlideUp')
    ) {
      filterSection.parentNode.classList.remove('sectionSlideUp');
    }
  }

  let filtersDataFromSitecore = '';
  if (isSolrResponseForFiltersAvailable) {
    filtersDataFromSitecore = updateFilterData(solRresponse, filters, dictionary);
  }
  const propsFiltersData = get(props, 'filtersData.data', '');
  const filtersTotalResult = get(props, 'filtersData.totalResults', '');
  let filtersData = (propsFiltersData.length > 0 && propsFiltersData) || filtersDataFromSitecore || [];

  let filtersDataLength = filtersTotalResult || solRresponse && solRresponse.totalResults;
  if (parentComponentName === 'FavoriteSubLayout') {
    filtersDataLength = favorites.length;
  }

  // Returning from component if filterData state is empty
  if (filtersData && filtersData.length === 0) {
    return '';
  }

  // Creating and updating dummy state for filters on mobile
  if (
    dummyFiltersData.length === 0 ||
    (filtersData &&
      filtersData.length > 0 &&
      !isStateEqual(dummyFiltersData, filtersData) &&
      isEqual(
        props.selectedFiltersData.data,
        extractFiltersFromFiltersData(filtersData)
      ) &&
      shouldUpdateDummyState)
  ) {
    let data = cloneDeep(filtersData);
    setDummyFiltersData(data);
    setDummyFiltersLength(props.selectedFiltersData.filterCount);
  }

  const payloadForAttributeListingAPICall = () => {
    let tagValue;
    let solrPayloadToFetchFilter = {};
    if (canUseDOM) {
      const params = new URLSearchParams(window.location.search);
      tagValue = params && params.get(TAG_TEXT);
    }
    solrPayloadToFetchFilter.contentType = contentType;
    solrPayloadToFetchFilter.language = language;
    solrPayloadToFetchFilter.facetFields = [];
    //For attribute listing page initial card limits are driven by sitecore,
    solrPayloadToFetchFilter.limit = Number(
      getDictionaryText('attributePageLoadCount')
    );
    solrPayloadToFetchFilter.offset = 0;
    solrPayloadToFetchFilter.filters = [{ key: TAG_TEXT, value: tagValue }];
    solrPayloadToFetchFilter.isPreviewMode = isEditor;

    return solrPayloadToFetchFilter;
  };

  /*
   *  This function gets called when user is on global search result page and needs to fetch intial
   *  search response when user either clicks on clearAll button or removes all filters
   */
  const fetchSearchResults = (searchTerm, language) => {
    let solrPayloadToFetchFilter = {
      searchTerm: searchTerm,
      language: language,
      facetFields: [],
      limit: 9,
      offset: 0,
      filters: [],
      isPreviewMode: isEditor,
    };
    var SolrFilterAPIURL = apiUrl.SOLR_FILTERS_DATA;
    if (parentComponentName === 'FavoriteSubLayout') {
      SolrFilterAPIURL = apiUrl.SOLR_FAVORITE_SEARCH_API
    }
    props.getFilterdInfoData({
      apiUrl: `${isGlobalSearchTemplate
        ? apiUrl.SOLR_SEARCH_API
        : SolrFilterAPIURL
        }`,
      payload: solrPayloadToFetchFilter,
    });
  };

  /*
   *  This function gets called when user clicks on View All listing on filter seaction
   *  this returns all responses for that listing page
   */
  const fetchAllResults = (contentType, language) => {

    let favData = [];
    var SolrFilterAPIURL = apiUrl.SOLR_FILTERS_DATA;

    if (parentComponentName === 'FavoriteSubLayout') {
      favData = JSON.parse(getLocalStorage('favorites') || '[]');
      SolrFilterAPIURL = apiUrl.SOLR_FAVORITE_SEARCH_API
      contentType = 'favorites';
    }
    let solrPayloadToFetchFilter = {
      contentType: contentType,
      language: language,
      facetFields: [],
      itemIDs: favData,
      limit: 9,
      offset: 0,
      filters: [],
      isPreviewMode: isEditor,
      sortingOrder: {
        order: 'asc',
        sortBy: 'name',
      },
    };

    if (category) {
      solrPayloadToFetchFilter.filters.push({
        key: get(category, 'taxonomyKey.value', ''),
        value: get(category, 'searchKey.value', ''),
      });
    }
    props.clearFilterData();


    props.getFilterdInfoData({
      apiUrl: `${SolrFilterAPIURL}`,
      payload: solrPayloadToFetchFilter,
    });
  };

  const payloadForSearchCall = (language) => {
    let favData = JSON.parse(getLocalStorage('favorites') || '[]');

    let solrPayloadToFetchFilter = {};
    solrPayloadToFetchFilter.itemIDs = favData;
    solrPayloadToFetchFilter.language = language;
    solrPayloadToFetchFilter.facetFields = [];
    solrPayloadToFetchFilter.limit = 9;
    solrPayloadToFetchFilter.offset = 0;
    solrPayloadToFetchFilter.filters = [];

    return solrPayloadToFetchFilter;
  };

  const fetchFavoriteListing = () => {
    const { appConfig = {} } = props;

    const payload = payloadForSearchCall(language);
    props.getFilterdInfoData({
      apiUrl: `${appConfig.SOLR_FAVORITE_SEARCH_API}`,
      payload: payload,
    });
  };

  const fetchAttributeListingDataOnClearAllFilters = () => {
    let solrPayloadToFetchFilter = payloadForAttributeListingAPICall();

    props.getFilterdInfoData({
      apiUrl: apiUrl.SOLR_FILTERS_DATA,
      payload: solrPayloadToFetchFilter,
    });
  };

  /*
   *  This function gets called when user chagnes filters on mobile
   */
  const onChangeMobile = event => {
    const target = {
      name: event.target.name,
      value: event.target.value,
      checked: event.target.checked,
    };
    addAnalyticsInfo(target, true);
    setIsFirstLoad(false);
    let data = cloneDeep(dummyFiltersData);
    let filtersLength = dummyFiltersLength;
    data.map(value => {
      if (value.fieldName.value === target.name) {
        if (value.type === checkboxType) {
          value.listItems.map(list => {
            if (list.fields.key.value === target.value) {
              list.fields.selected.value = target.checked;
            }

            return list;
          });
        } else {
          value.selectedValue.value = target.value;
        }
      } else if (value.type === calendarType) {
        if (target.name === dateRangeKeys.startDate) {
          value.startDate.value = target.value;
        } else if (target.name === dateRangeKeys.endDate) {
          value.endDate.value = target.value;
        }
      }

      return value;
    });

    filtersLength = getFilterCount(extractFiltersFromFiltersData(data));
    setDummyFiltersData(data);
    setShouldUpdateDummyState(false);
    setDummyFiltersLength(filtersLength);
    if (isADeventFilters) {
      setAdCalendarFiltersDesktop(data)
    }
  };

  /*
   *  This function checks selected filters with store state and existing component state
   *  and if they are not equal then call API to fetch latest results based on filters selected
   */
  const removeGtmFilters = (items = {}) => {
    const arr = getDictionaryText('nonremoveablefilters')?.split(',') || []
    return Object.keys(items).reduce((acc, key) => {
      if (!arr.includes(key)) {
        acc[key] = items[key];
      }
      return acc;
    }, {});
  }

  const updateSelectedFilters = filtersData => {
    const selectedFilters = extractFiltersFromFiltersData(filtersData);
    const isEmptyObject = isFilterObjectEmpty(selectedFilters);
    const isEmptyObjectWithoutGtm = isFilterObjectEmptyWithoutGTMValues(selectedFilters);
    if (!isEmptyObject) {
      let urlQueryParams = cloneDeep(selectedFilters);
      urlQueryParams = removeEmpty(urlQueryParams);
      if (isGlobalSearchTemplate) {
        urlQueryParams.searchTerm = searchTerm;
      }
      const query = queryString.stringify(urlQueryParams, {
        arrayFormat: 'comma',
      });
      if (canUseDOM) {
        if (isADeventFilters) setStopHitsOnFilters(true)
        window.history.replaceState(
          { turbolinks: {} },
          '',
          `?${query}${contentType === ATTRIBUTE_TYPE
            ? `&${TAG_TEXT}=${attributeListingTag}`
            : ''
          }`
        );
      }
    } else {
      if (isGlobalSearchTemplate) {
        const query = queryString.stringify(
          { searchTerm: searchTerm },
          {
            arrayFormat: 'comma',
          }
        );
        if (canUseDOM) {
          window.history.replaceState({ turbolinks: {} }, '', `?${query}`);
        }
      } else {
        window.history.replaceState(
          { turbolinks: {} },
          '',
          contentType === ATTRIBUTE_TYPE
            ? `?${TAG_TEXT}=${attributeListingTag}`
            : window.location.pathname
        );
      }
    }

    if (canUseDOM) {
      const metaOGUrl = document.querySelector('meta[name="og:url"]');
      // setting current url with filters in OG url meta tag
      // so every time filter gets changes we have updated sharable URL
      if (metaOGUrl) {
        metaOGUrl.content = window.location.href
      }
    }

    if (!isEqual(removeGtmFilters(props.selectedFiltersData.data), removeGtmFilters(selectedFilters))) {
      props.updateSelectedFiltersData({ filters: selectedFilters, isAdCalendar: isADeventFilters });
      if (!isEmptyObjectWithoutGtm) {
        // Fetching Filtered Results
        let payload = getSolrPayloadForFilters(
          selectedFilters,
          false,
          contentType,
          isGlobalSearchTemplate,
          searchTerm,
          language,
          category,
          filtersData,
          isEditor,
          attributeListingTag,
          props
        );
        var SolrFilterAPIURL = apiUrl.SOLR_FILTERS_DATA;

        if (parentComponentName === 'FavoriteSubLayout') {
          SolrFilterAPIURL = apiUrl.SOLR_FAVORITE_SEARCH_API
        }
        if (isADeventFilters && adCalendarFiltersDesktop.length === 0) {
          setAdCalendarFiltersDesktop(filtersData)
        }
        const hasGtm = Array.isArray(payload?.filters) && payload?.filters.find(x => getDictionaryText('nonremoveablefilters').includes(x.key))
        const removeGtmFilters = Array.isArray(payload?.filters) && payload?.filters.filter(x => !getDictionaryText('nonremoveablefilters').includes(x.key)) || []
        payload = { ...payload, filters: removeGtmFilters }
        const hasTrue = payload?.dateRange || removeGtmFilters.length > 0
        if (payload && hasTrue) {
          if (isADeventFilters) {
            const filtersToAvoid = ['period']
            toggleDisplayOfFeaturedSection({ filtersData, adEventTabs, filterAdCalendarByDays })
            const found = Array.isArray(payload.filters) && payload.filters.find(o => o.key === filtersToAvoid[0])
            if (found) {
              const { startDate, endDate } = getStartAndEndDate(found.value)
              payload = { ...payload, filters: payload.filters.filter(o => !filtersToAvoid.includes(o.key)), startDate, endDate }
            } else if (filterAdCalendarByDays.calendar.endDate) {
              const { startDate, endDate } = filterAdCalendarByDays.calendar || {}
              payload = { ...payload, startDate: moment(startDate, 'MM-DD-YYYY').format('MM-DD-YYYY'), endDate: moment(endDate, 'MM-DD-YYYY').format('MM-DD-YYYY') }
            }
          }

          props.getFilterdInfoData({
            apiUrl: `${isGlobalSearchTemplate
              ? apiUrl.SOLR_SEARCH_API
              : SolrFilterAPIURL
              }`,
            payload: payload,
          });
        }
        if (removeGtmFilters.length === 0 && hasGtm) {
          props.clearFilteredData();
        }
      } else {
        // this will fetch intial search results in case user clears all applied filters
        if (isGlobalSearchTemplate) {
          if (!isFirstLoad) {
            fetchSearchResults(searchTerm, language);
          } else if (clearAllClickedData && clearAllClickedData.data) {
            setTimeout(() => {
              fetchSearchResults(searchTerm, language);
            }, 10);
            if (clearAllClickedData && clearAllClickedData.data) {
              props.clearAllClicked(false);
            }
          }
        } else if (contentType === ATTRIBUTE_TYPE) {
          fetchAttributeListingDataOnClearAllFilters();
        } else if (props.params?.isEventListPage) {
          if (!isFirstLoad) {
            const payload = { contentType, language, facetFields: [], offset: 0, filters: [], limit: Number(getDictionaryText('attributePageLoadCount')) }
            props.getFilterdInfoData({
              apiUrl: `${props.appConfig.SOLR_FILTERS_DATA}`,
              payload: payload,
            });
          }
          return
        } else {
          props.clearFilteredData();
        }
      }
    }
  };

  if ((isADeventFilters && !stopHitsOnFilters && !shouldCheckURL) || (!isADeventFilters && !shouldCheckURL)) {
    updateSelectedFilters(filtersData);
  }
  // Reading URl and applying filters added in URL
  if (canUseDOM && shouldCheckURL) {
    const searchString = queryString.parse(
      window && window.location && window.location.search,
      { arrayFormat: 'comma' }
    );
    searchString && searchString.tag && setAttributeListing(searchString.tag);
    if (Object.keys(searchString).length !== 0) {
      let updatedfiltersData = cloneDeep(filtersData);
      updatedfiltersData.map(data => {
        const value = searchString[data.fieldName.value]
          ? searchString[data.fieldName.value]
          : '';
        if (data.type === checkboxType) {
          data.listItems = data.listItems.map(listItem => ({
            ...listItem,
            fields: {
              ...listItem.fields,
              selected: {
                ...listItem.fields.selected,
                value: Array.isArray(value) && value.length > 0
                  ? value.includes(listItem.fields.key.value)
                  : listItem.fields.key.value === value
              }
            }
          }));
        } else if (data.type === calendarType) {
          if (searchString.startDate && searchString.endDate) {
            let this_stateDate = moment(searchString.startDate, 'MM-DD-YYYY');
            let this_endDate = moment(searchString.endDate, 'MM-DD-YYYY');
            data.startDate.value = this_stateDate.toDate();
            data.endDate.value = this_endDate.toDate();
          }
        } else if (data.type === 'gtm') {
          data.listItems.map(listItem => {
            listItem.fields.selected.value = true;
            return listItem;
          });
        } else {
          data.selectedValue.value = value;
        }
        return data;
      });
      setTimeout(() => {
        props.updateQueryFilterData(updatedfiltersData);
      }, 0);
    }
    setShouldCheckURL(false);
  }
  /*
   *  This function gets called when user open filters drawer on mobile
   */
  const toggleDrawer = () => {
    closeInterestsDrawer()
    setShouldOpenDrawer(!shouldOpenDrawer);
  };

  /*
   *  This function gets called when user clicks apply button on mobile after selecting filters
   */

  const onApplySubmitForMobile = () => {
    if (isADeventFilters) {
      const extractItemsFromDummyFilter = ['eventtypes', 'location_regions', 'location_titles']
      const dummyFiltersItems = dummyFiltersData.filter(item => extractItemsFromDummyFilter.includes(item.fieldName.value))
      const filtersItems = filtersData.filter(item => !extractItemsFromDummyFilter.includes(item.fieldName.value))
      const combinedFilters = [...filtersItems, ...dummyFiltersItems]
      updateFiltersStateAndURL({ items: combinedFilters, shouldUpdateSelectedFilter: true })
      const filters = getSelectedFiltersForPayload({ filters: combinedFilters })
      const payload = getApiPayload({ filters, adEventTabs, filterAdCalendarByDays })
      fetchFiltersResultApi(payload)
      toggleDisplayOfFeaturedSection({ filters: combinedFilters, adEventTabs, filterAdCalendarByDays })
      window.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      props.mobileFiltersUpdate(dummyFiltersData);
    }
    toggleDrawer();
  };

  const handleResetAllBtnMobile = () => {
    onCloseClickMobile();
    props.clearFilterData(isADeventFilters);
    const item = handleAdCalendarFiltersValue(dummyFiltersData)
    setDummyFiltersData(item)
    setDummyFiltersLength(0)
    onClearAllClick()
  }

  /*
   *  This function handles onChange events of filters on desktop
   */
  const onFilterChange = event => {
    const target = {
      name: event.target.name,
      value: event.target.value,
      checked: event.target.checked,
    };

    if (isADeventFilters) {
      const items = handleAdCalendarFiltersValue(target)
      setAdCalendarFiltersDesktop(items)
    }
    addAnalyticsInfo(target);
    setIsFirstLoad(false);
    if (!isADeventFilters) props.updateFiltersData(target);
    if (parentComponentName === 'FavoriteSubLayout') {
      fetchFavoriteListing();
    }

  };
  /*
   *  This function returns typography text based on label, variant and classname provided
   */
  const renderText = (label, variant, className, component) => {
    return (
      <Typography variant={variant} component={component} gutterBottom={false} className={className}>
        <Text field={label} />
      </Typography>
    );
  };

  /*
   *  This function set mobile state to intial state when the filters popup was earlier opened in case of mobile
   */
  const onCloseClickMobile = () => {
    if (filtersData && filtersData.length > 0) {
      let data = cloneDeep(filtersData);
      setDummyFiltersData(data);
      setDummyFiltersLength(props.selectedFiltersData.filterCount);
    }
  };

  /*
   *  This function clears filters present on mobile filters state
   */
  const onResetClickMobile = () => {
    if (dummyFiltersData && dummyFiltersData.length > 0) {
      let data = dummyFiltersData;
      data.map(value => {
        if (value.type === checkboxType) {
          value.listItems.map(list => {
            list.fields.selected.value = false;

            return list;
          });
        } else if (value.type === calendarType) {
          value.startDate.value = '';
          value.endDate.value = '';
        } else {
          value.selectedValue.value = '';
        }

        return value;
      });
      setDummyFiltersData(data);
      setDummyFiltersLength(0);
    }
  };

  /*
   *  This function renders link
   */
  const renderLink = (linkText, className, onClick) => {
    return (
      <CustomLink
        link={{
          value: { href: '', title: '', target: '', class: '' },
        }}
        className={className}
        onClick={e => {
          e.preventDefault();
          onClick();
        }}
      >
        {renderText(linkText, 'body2Bold')}
      </CustomLink>
    );
  };

  /*
   *  This function returns filters fields from the filtersData state
   *  along with bind all the helper functions required
   */
  const renderFiltersFields = (filtersData, onChangeFunc) => {
    filtersData = isADeventFilters ? filtersData.filter(o => !FILTERS_TO_AVOID_IN_AD_CALENDAR.includes(o.fieldName?.value || '')) : filtersData
    return filtersData.map((data, index) => {
      const Field = mapper[data.type];
      if (Field) {
        return (
          <div
            className={clsx(
              classes.container,
              data.type === dropdownType && classes.dropdown,
              // This comments for Event page
              contentType === EVENT_TYPE && classes.eventColor,
              isADeventFilters ? 'AdEventColor' : ''
            )}
            key={index}
          >
            <Field
              data={data}
              onChange={onChangeFunc}
              seeLessText={seeLessText}
              seeMoreText={seeMoreText}
              shouldShowLimited
              shouldShowResultsCount={isGlobalSearchTemplate}
              isGroupedDropdown={data.fieldName.value === regionTaxonomyKey}
              isFilterRating={data.fieldName.value === tripadvisorratingTaxonomyKey}
            />
            {data.fieldName.value === priceTaxonomyKey ? (
              <div className={classes.priceRangeText}>
                {renderText(priceRangeHelpText, 'body2')}
              </div>
            ) : (
              ''
            )}
          </div>
        );
      }

      return null;
    });
  };

  /*
   *  This function gets called when user clickes clearALL on browser
   */
  const onClearAllClick = () => {
    if (isADeventFilters) {
      if (!isMobile) {
        props.clearFilterData(isADeventFilters);
        props.clearAllClicked(true);
      }
      resetAdCalendarSelections()
    } else {
      props.clearFilterData();
      props.clearAllClicked(true);
      if (isGlobalSearchTemplate) {
        fetchSearchResults(searchTerm, language);
      }
      if (parentComponentName === 'FavoriteSubLayout') {
        fetchFavoriteListing();
      }
    }
  };

  /*
   *  This function returns filters section HTML
   */
  const createSVG = (type = '', fill = '', customClass = '') => {
    switch (type) {
      case 'filter':
        return (
          <svg className={customClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12.2012" cy="10" r="2" stroke="white" stroke-width="2" />
            <circle cx="4.20117" cy="6" r="2" transform="rotate(180 4.20117 6)" stroke="white" stroke-width="2" />
            <rect x="11.2012" y="12" width="2" height="3" rx="1" fill="white" />
            <rect x="5.20117" y="4" width="2" height="3" rx="1" transform="rotate(180 5.20117 4)" fill="white" />
            <rect x="11.2012" y="1" width="2" height="7" rx="1" fill="white" />
            <rect x="5.20117" y="15" width="2" height="7" rx="1" transform="rotate(180 5.20117 15)" fill="white" />
          </svg>
        )
        break;
      case 'cross':
        return (
          <svg className={customClass} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 2L10 10M2 10L10 2" stroke="white" stroke-width="2" stroke-linecap="round" />
          </svg>
        )
        break;
      case 'interest':
        return (
          <svg className={customClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 17C10 17.5523 10.4477 18 11 18H13C13.5523 18 14 17.5523 14 17C14 16.4477 13.5523 16 13 16H11C10.4477 16 10 16.4477 10 17Z" fill="black" />
            <path d="M4 6C3.44772 6 3 6.44772 3 7C3 7.55228 3.44772 8 4 8H20C20.5523 8 21 7.55228 21 7C21 6.44772 20.5523 6 20 6H4Z" fill="black" />
            <path d="M6 12C6 12.5523 6.44772 13 7 13H17C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11H7C6.44772 11 6 11.4477 6 12Z" fill="black" />
          </svg>
        )
      case 'calender':
        return (
          <svg className={customClass} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.03769 2.5V5.5M12.9636 2.5V5.5M3.33398 8.5H16.6673M4.81547 4H15.1858C16.004 4 16.6673 4.67157 16.6673 5.5V16C16.6673 16.8284 16.004 17.5 15.1858 17.5H4.81547C3.99727 17.5 3.33398 16.8284 3.33398 16V5.5C3.33398 4.67157 3.99727 4 4.81547 4Z" stroke="#565A5C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        )
        break;
        return <></>
    }
  }
  const isRTL = language == 'ar' || language == 'he';

  const fetchFiltersResultApi = (params) => {
    const payload = { contentType, language, facetFields: [], offset: 0, filters: [], limit: Number(getDictionaryText('attributePageLoadCount')), ...(params && { ...params }) }
    props.getFilterdInfoData({
      apiUrl: `${props.appConfig.SOLR_FILTERS_DATA}`,
      payload: payload,
    });

  }

  const checkboxItems = ['location_regions', 'location_titles', 'eventtypes']
  const dropdownItems = ['eventcategories', 'period']
  const calendarItems = ['startdt_t|enddt_t']

  const handleAdCalendarFiltersValue = (target, resetFilters = false) => {
    const resetFiltersHandler = (value) => {
      // Reset selected values for all list items
      value.listItems.forEach(list => {
        list.fields.selected.value = false;
      });

      // Reset calendar values
      if (calendarItems.includes(value.fieldName.value)) {
        value.startDate.value = '';
        value.endDate.value = '';
      }
    };

    const handleCheckboxUpdate = (value) => {
      value.listItems.forEach(list => {
        if (list.fields.key.value === target.value) {
          list.fields.selected.value = target.checked ? true : '';
        }
      });
    };

    const handleDropdownUpdate = (value) => {
      value.listItems = value.listItems.map(list => {
        const isMatchingKey = value.fieldName.value === 'eventcategories' && target.value.split(',').includes(list.fields.key.value) || list.fields.key.value === target.value;
        return { ...list, fields: { ...list.fields, selected: { ...list.fields.selected, value: isMatchingKey ? (target.checked ? true : '') : '' } } };
      });
    };

    const handleCalendarUpdate = (value) => {
      value.startDate.value = target.startDate;
      value.endDate.value = target.endDate;
    };

    return filtersData.map(value => {
      const checkName = target.name === value.fieldName.value
      switch (true) {
        case resetFilters:
          resetFiltersHandler(value);
          break;
        case checkboxItems.includes(target.name) && checkName:
          handleCheckboxUpdate(value);
          break;
        case dropdownItems.includes(target.name) && checkName:
          handleDropdownUpdate(value);
          break;
        case calendarItems.includes(target.name) && checkName:
          handleCalendarUpdate(value);
          break;
      }

      return value;
    });
  };

  const renderEventHandler = (key = '', params) => {
    switch (key) {
      case 'TopBanner':
        handleAddCalendarTopBanner(params)
        break;

      case 'DaysTab': // this_week, this_month, next_month
        handleSelectedDays(params)
        break;

      case 'Datepicker':
        handleAdCalendarFilterDatepickerChange(params)
        break;

      case 'submitFiltersForDesktop':
        handleSubmitFilters()
        break;

      case 'submitFiltersForMobile':
        onApplySubmitForMobile()
        break;

      default:
        break;
    }
  }

  const updateFilters = (items, counts) => {
    if (isMobile) { props.mobileFiltersUpdate({ items, counts }) }
    else { props.updateFiltersForAdCalendarData({ items, counts }) }
  }

  const updateURL = (selectedFilters, extras = {}) => {
    handleUpdateQueryParamsForFilter({ selectedFilters: { ...selectedFilters, ...extras }, isGlobalSearchTemplate, searchTerm })
  }

  const updateFiltersStateAndURL = ({ items, apiResponse, counts, extras, shouldUpdateSelectedFilter = false }) => {
    const selectedFilters = extractFiltersFromFiltersData(items);
    updateFilters(items, counts)
    updateURL(selectedFilters, extras)
    if (shouldUpdateSelectedFilter) props.updateSelectedFiltersData({ filters: selectedFilters, isAdCalendar: isADeventFilters });
    if (apiResponse) props.getFilterdInfoSuccess({ results: apiResponse.data.data })
  }


  const handleAddCalendarTopBanner = async (params) => {
    const targets = [{ name: params.key, value: params.value, checked: true }];
    let items = toggleTargetFilters({ targets, filtersData })
    updateFiltersStateAndURL({ items })
    const filters = getSelectedFiltersForPayload({ filters: items })
    const payload = getApiPayload({ filterAdCalendarByDays, filters })
    fetchFiltersResultApi(payload)
    displayFeatureSection('TopBanner', { adEventTabs, params, filterAdCalendarByDays, filters })
    setFilterAdCalendarByDays(prevState => ({ ...prevState, params }));
  }

  const handleSelectedDays = ({ selectedTab, taxonomyKey }) => {
    const dates = selectedTab !== adEventTabs ? getStartAndEndDate(taxonomyKey) : { startDate: null, endDate: null }
    const targets = [{ name: 'period', value: periodFilters[selectedTab], checked: adEventTabs !== selectedTab }, { name: 'startdt_t|enddt_t', startDate: '', endDate: '' }]
    setAdEventTabs((prevTab) => prevTab === selectedTab ? null : selectedTab);
    const items = toggleTargetFilters({ targets, filtersData })
    updateFiltersStateAndURL({ items, ...(selectedTab !== adEventTabs && { extras: { period: periodFilters[selectedTab] } }) })
    const filters = getSelectedFiltersForPayload({ filtersData })
    displayFeatureSection('SelectDaysRangeTab', { filters, adEventTabs, selectedTab, filterAdCalendarByDays })
    const payload = getApiPayload({ filters, adEventTabs, selectedTab, dates })
    fetchFiltersResultApi(payload)
    setFilterAdCalendarByDays(prevState => ({ ...prevState, ...dates, calendar: { startDate: null, endDate: null } }));
  }

  const handleAdCalendarFilterDatepickerChange = (dates) => {
    const [startDate, endDate] = dates;
    setFilterAdCalendarByDays(prevState => ({ ...prevState, startDate: null, endDate: null, calendar: { startDate, endDate } }))
    let filters = getSelectedFiltersForPayload({ filtersData })
    filters = excludeGTMTags(filters)
    if (startDate && endDate) {
      const targets = [...(adEventTabs != null ? [{ name: 'period', value: periodFilters[adEventTabs], checked: false }] : []), { name: 'startdt_t|enddt_t', startDate, endDate }];
      updateFiltersStateAndURL({ items: toggleTargetFilters({ targets, filtersData }) })
      setAdEventTabs(null)
      displayFeatureSection('forceHide')
      fetchFiltersResultApi(getApiPayload({ filters, startDate, endDate }))
    } else if (!startDate) {
      const targets = [{ name: 'startdt_t|enddt_t', startDate: '', endDate: '' }];
      updateFiltersStateAndURL({ items: toggleTargetFilters({ targets, filtersData }) })
      displayFeatureSection('DatepickerSelection', { filters, adEventTabs, filterAdCalendarByDays })
      fetchFiltersResultApi({ filters })
    }
  };

  // Submit Desktop Filters
  const handleSubmitFilters = async () => {
    setEditMenu(prev => !prev)
    if (!adCalendarFiltersDesktop.length) return;
    updateFiltersStateAndURL({ items: adCalendarFiltersDesktop, shouldUpdateSelectedFilter: true })
    const filters = getSelectedFiltersForPayload({ filtersData })
    const payload = getApiPayload({ filterAdCalendarByDays, filters, adEventTabs })
    fetchFiltersResultApi(payload)
    toggleDisplayOfFeaturedSection({ filtersData, filterAdCalendarByDays, adEventTabs })
  }

  const RenderAdCalendarButtons = () => {
    return (
      <>
        {bannerWithEventFilter.fields.date.map(({ fields }, index) => (
          <ButtonMUI
            size={'small'}
            hideEndIcon={"false"}
            buttonType={'form'}
            className={`${classes.filterBTN} ${index === adEventTabs ? 'active' : ''} `}
            type={'button'}
            hasBorder={false}
            iconOnly={false}
            onClick={() => renderEventHandler('DaysTab', { selectedTab: index, taxonomyKey: fields.taxonomyKey.value })}
          >{fields.taxonomyValue.value} {index === adEventTabs && createSVG('cross')}</ButtonMUI>
        ))}

      </>
    )
  }

  const trackRtlStyle = (style) => isRTL ? { marginLeft: style.marginRight, marginRight: 0, } : {};

  const getLabelForDatePicker = () => {
    return `${filterAdCalendarByDays.calendar.endDate && (moment(filterAdCalendarByDays.calendar.startDate, 'MM-DD-YYYY').format('DD.MM.YYYY') + ' - ') || ''} ${filterAdCalendarByDays.calendar.endDate && moment(filterAdCalendarByDays.calendar.endDate, 'MM-DD-YYYY').format('DD.MM.YYYY') || ''}`
  }

  const removeAdFiltersSelectedWithoutSubmit = () => {
    const selectedFiltersData = props.selectedFiltersData.data
    const checkboxItems = ['location_regions', 'location_titles', 'eventtypes']
    const items = filtersData.map(value => {
      const selectedItems = selectedFiltersData[value.fieldName.value] || []
      if (checkboxItems.includes(value.fieldName.value)) {
        value.listItems.map(list => {
          return list.fields.selected.value = selectedItems.includes(list.fields.key.value);
        });
      }
      return value;
    })
    if (isMobile) {
      setDummyFiltersData(items)
    } else {
      setAdCalendarFiltersDesktop(items)
    }
  }

  const handleClickAwayFilters = () => {
    setEditMenu(false)
    removeAdFiltersSelectedWithoutSubmit()
  }

  const filterDOM = (isCalenderDrawer = false) => {
    let updatedTitle = `${title.value}${props.selectedFiltersData.filterCount
      ? `(${props.selectedFiltersData.filterCount})`
      : ''
      }`;
    let selectedFilter = `${dummyFiltersLength
      ? `( ${dummyFiltersLength} ) ${selectedFilterText.value}`
      : ''
      }`;
    return (
      <>
        {isADeventFilters && !isCalenderDrawer ?
          (

            <Box className={classes.mainHeadingContainer}>
              {/* commented for phase 2 */}
              {/* {
                isMobile && isScrolled
                  ? (
                    <StickyBar className='stickyCta' mobileBottomSticky={false}>
                      <Box className='mobileStickyWrapper'>
                        <ButtonMUI
                          size={'small'}
                          hideEndIcon={"false"}
                          buttonType={'form'}
                          className={`${classes.filterBTN} mobileInterests`}
                          type={'button'}
                          hasBorder={false}
                          iconOnly={false}
                        >{createSVG('interest')}{getDictionaryText('ADInterests')}</ButtonMUI>
                        <ButtonMUI
                          size={'small'}
                          hideEndIcon={"false"}
                          buttonType={'form'}
                          className={`${classes.filterBTN} mobileFilter`}
                          type={'button'}
                          hasBorder={false}
                          iconOnly={false}
                          onClick={() => {
                            if (isMobile) {
                              toggleDrawer();
                            }
                          }}
                        >{createSVG('filter')}{getDictionaryText('ADFilter')}</ButtonMUI>
                      </Box>
                    </StickyBar>
                  )
                  : (
                    <Box className='filterWrap'>
                      <Box className='dateFilters'>
                        <RenderAdCalendarButtons />
                      </Box>
                      <Box className='filtersInner'>
                        <ButtonMUI
                          size={'small'}
                          hideEndIcon={"false"}
                          buttonType={'form'}
                          className={`${classes.filterBTN} filters`}
                          type={'button'}
                          hasBorder={false}
                          iconOnly={false}
                          onClick={() => {
                            if (isMobile) {
                              toggleDrawer();
                            }
                            setEditMenu(prev => !prev)
                          }}
                        >{createSVG('filter')}{!isMobile ? getDictionaryText('ADFilter') : ''} </ButtonMUI>
                      </Box>
                    </Box>
                  )
              } */}
              <Box className='filterWrap'>
                <Box className='dateFilters'>
                  <RenderAdCalendarButtons />
                  <DatePicker
                    selected={filterAdCalendarByDays.calendar.startDate}
                    onChange={(dates) => renderEventHandler('Datepicker', dates)}
                    startDate={filterAdCalendarByDays.calendar.startDate}
                    endDate={filterAdCalendarByDays.calendar.endDate}
                    isClearable
                    selectsRange
                    customInput={
                      <ButtonMUI
                        ButtonMUI
                        size={'small'}
                        hideEndIcon={"false"}
                        buttonType={'form'}
                        className={`${classes.filterBTN} ${filterAdCalendarByDays.calendar.startDate && filterAdCalendarByDays.calendar.endDate && 'activeCalender'} calender`}
                        type={'button'}
                        hasBorder={false}
                        iconOnly={false}>
                        {createSVG('calender')} {getLabelForDatePicker()} <span className='crossOn' onClick={(event) => {
                          event.stopPropagation(); // This will prevent the button's onClick event
                        }}></span>
                      </ButtonMUI>
                    }
                  />
                </Box>
                <Box className='filtersInner'>
                  <ButtonMUI
                    size={'small'}
                    hideEndIcon={"false"}
                    buttonType={'form'}
                    className={`${classes.filterBTN} filters`}
                    type={'button'}
                    hasBorder={false}
                    iconOnly={false}
                    onClick={() => {
                      if (isMobile) {
                        toggleDrawer();
                      }
                      setEditMenu(prev => !prev)
                    }}
                  >{createSVG('filter')} {!isMobile ? (<>{getDictionaryText('ADFilter')}</>) : ''} {filterCount > 0 ? (<span className='filterCount'>{filterCount}</span>) : ''}
                  </ButtonMUI>
                </Box>
              </Box>
              {
                editMenu && !isMobile &&
                <ClickAwayListener onClickAway={() => handleClickAwayFilters()}>
                  <Paper elevation={8} className='editMenu' >
                    <MenuList>
                      <MenuItem>
                        <ListItemText>

                          <div className={`${classes.filterSection} ADEventFilter`}>
                            <div className={`${classes.container} ADContainer`}>
                              {renderText(
                                { value: updatedTitle },
                                'body2Bold',
                                classes.filterText,
                                'h2'
                              )}
                              {props.selectedFiltersData.filterCount ? (
                                <Hidden mdDown implementation="css">
                                  {renderLink(
                                    clearAllText,
                                    classes.clearAllButton,
                                    onClearAllClick
                                  )}
                                </Hidden>
                              ) : (
                                ''
                              )}
                              {props.selectedFiltersData.filterCount ? (
                                <Hidden lgUp implementation="css">
                                  {renderLink(resetText, classes.resetButton, onResetClickMobile)}
                                </Hidden>
                              ) : (
                                ''
                              )}
                              <Hidden lgUp implementation="css">
                                <DctSvgIcon
                                  name="CloseIcon"
                                  onClick={() => {
                                    toggleDrawer();
                                    onCloseClickMobile();
                                  }}
                                />
                              </Hidden>
                            </div>
                            <Scrollbars
                              autoHide
                              autoHideTimeout={1000}
                              autoHideDuration={200}
                              autoHeight
                              // autoHeightMax={`calc((var(--vh, 1vh) * 100) - var(--notificationBar) - var(--headerHeight) - 216px)`}
                              autoHeightMax={`calc(713px - 137px)`}
                              id="nrscroll"
                              universal={true}
                              renderView={({ style, props }) => <div {...props} style={{ ...style, scrollBehavior: 'smooth', ...trackRtlStyle(style) }} />}
                              renderTrackVertical={({ style, ...props }) => <div {...props} style={{ ...style }} className={classes.destinationScrollTrack} />}
                              renderThumbVertical={({ style, ...props }) => <div {...props} style={{ ...style }} className={classes.destinationScrollThumb} />}
                            >
                              {isMobile
                                ? renderFiltersFields(dummyFiltersData, onChangeMobile)
                                : renderFiltersFields(filtersData, onFilterChange)}
                            </Scrollbars>
                            <Hidden lgUp implementation="css">
                              <div className={classes.mobileFooter}>
                                {renderText(
                                  { value: selectedFilter },
                                  'body2Bold',
                                  classes.heading
                                )}
                                <ButtonMUI
                                  buttonType={'form'}
                                  type={'button'}
                                  onClick={() => renderEventHandler('submitFiltersForMobile')}
                                  hasBorder={false}
                                  field={{ value: { text: applyText && applyText.value } }}
                                  iconOnly={false}
                                  // This comments for Event page
                                  className={contentType === EVENT_TYPE ? classes.eventBtnColor : ''}
                                />
                              </div>
                            </Hidden>
                          </div>
                          <Box className='ctaWrapper'>
                            <ButtonMUI
                              // size={'large'}
                              buttonType={'form'}
                              className={`${classes.filterBTN} showEvents`}
                              type={'button'}
                              hasBorder={false}
                              iconOnly={false}
                              onClick={() => renderEventHandler('submitFiltersForDesktop')}
                            >{getDictionaryText('ADShowEvents')}</ButtonMUI>
                          </Box>
                        </ListItemText>
                      </MenuItem>

                    </MenuList>
                  </Paper>
                </ClickAwayListener>
              }
            </Box >
          )
          : (
            <div className={`${classes.filterSection} ${isADeventFilters ? 'ADEventFilter' : ''}`}>
              <div className={`${classes.container} ${isADeventFilters ? 'ADContainer' : ''}`}>
                <Hidden mdDown implementation="css">
                  {renderText(
                    { value: updatedTitle },
                    'body2Bold',
                    classes.filterText,
                    'h2'
                  )}
                </Hidden>
                <Hidden lgUp implementation="css">
                  {renderText(title, 'body2Bold', `${classes.filterText} ${isADeventFilters ? 'textLeft' : ''}`,)}
                </Hidden>
                {props.selectedFiltersData.filterCount ? (
                  <Hidden mdDown implementation="css">
                    {renderLink(
                      clearAllText,
                      classes.clearAllButton,
                      onClearAllClick
                    )}
                  </Hidden>
                ) : (
                  ''
                )}
                {props.selectedFiltersData.filterCount ? (
                  <Hidden lgUp implementation="css">
                    {renderLink(resetText, `${classes.resetButton} ${isADeventFilters ? 'hide' : ''}`, onResetClickMobile)}
                  </Hidden>
                ) : (
                  ''
                )}
                <Hidden lgUp implementation="css">
                  {isADeventFilters ?
                    <>
                      <Typography variant={'body2Bold'} className={`${classes.ClearBTN} ${isADeventFilters ? 'AdClear' : ''}`} component="h3"
                        onClick={() => {
                          toggleDrawer();
                          onCloseClickMobile();
                        }
                        }><DctSvgIcon name="CloseIcon" /></Typography>
                    </>
                    :
                    (<DctSvgIcon
                      name="CloseIcon"
                      onClick={
                        () => {
                          toggleDrawer();
                          onCloseClickMobile();
                        }
                      }
                    />)
                  }

                </Hidden>
              </div>
              {isMobile
                ? renderFiltersFields(dummyFiltersData, onChangeMobile)
                : renderFiltersFields(filtersData, onFilterChange)}
              <Hidden lgUp implementation="css">
                <div className={`${classes.mobileFooter} ${isADeventFilters ? 'ADfooterStyle' : ''}`}>
                  {renderText(
                    { value: selectedFilter },
                    'body2Bold',
                    `${classes.heading} ${isADeventFilters ? 'hide' : ''}`
                  )}
                  {isADeventFilters ?
                    <ButtonMUI
                      buttonType={'form'}
                      type={'button'}
                      onClick={handleResetAllBtnMobile}
                      hasBorder={false}
                      field={{ value: { text: resetAllText && resetAllText.value } }}
                      iconOnly={false}
                      className={`${contentType === EVENT_TYPE ? classes.eventBtnColor : ''} borderBTN`}
                    />
                    : ''}
                  <ButtonMUI
                    buttonType={'form'}
                    type={'button'}
                    onClick={() => renderEventHandler('submitFiltersForMobile')}
                    hasBorder={false}
                    field={{ value: { text: applyText && applyText.value } }}
                    iconOnly={false}
                    // This comments for Event page
                    className={`${contentType === EVENT_TYPE ? classes.eventBtnColor : ''} applyCta`}
                  />
                </div>
              </Hidden>
            </div>
          )}

      </>
    );
  };
  if (props && !props.fields) {
    return null;
  }

  const renderInterestsMobDrawer = () => {
    return (
      <Box className={`${classes.interestsMobDrawer} js-interestsMobDrawer ${isHeaderVisible ? 'header_visible' : ''}`}>
        <Grid item className="interest_categories js-interest_categories">
          {
            adCalendarItems && adCalendarItems.length > 0 && adCalendarItems.map((adCalenderItem, i) => {
              const isActive = selectedEvent ? selectedEvent.fields === adCalenderItem.fields : i === 0;
              return (
                <Typography key={i} variant={'body3Bold'} className={`interests_category ${isActive && 'active'}`} component={'p'}
                  onClick={() => {
                    closeInterestsDrawer()
                    setSelectedEvent(adCalenderItem)
                    handleAddCalendarTopBanner({
                      key: 'eventcategories',
                      value: adCalenderItem.fields.SearchKey.value,
                    })
                    setAdCalendarTopBannerInitialValue({ key: 'eventcategories', value: adCalenderItem.fields?.SearchKey?.value.split(',') || [''] })
                    window.scrollTo({
                      top: 0,
                      behavior: 'smooth',
                    })
                  }}>
                  {adCalenderItem.fields.Title.value}
                </Typography>
              )
            })
          }
        </Grid>
      </Box>
    )
  }

  return (
    <>
      {
        isMobile && isADeventFilters &&
        <>
          <Box className={`${classes.mobStickyBar} ${showFilterStickybar ? 'show_sticky_bar' : ''} ${isHeaderVisible ? 'header_visible' : ''}`}>
            <Box className='mob_filter_btn'>
              <ButtonMUI
                size={'small'}
                hideEndIcon={"false"}
                buttonType={'form'}
                className={`interests_btn`}
                type={'button'}
                hasBorder={false}
                iconOnly={false}
                onClick={() => {
                  setShowMobInterestsDrawer(!showInterestsMobDrawer);
                  setEditMenu(prev => !prev)
                  document.body.classList.toggle('scrollControl');
                }}
              >{createSVG('interest')} <span>{`${getDictionaryText('InterestsText')}`}</span>
              </ButtonMUI>
            </Box>
            <Box className={'mob_filter_btn'}>
              <ButtonMUI
                size={'small'}
                hideEndIcon={"false"}
                buttonType={'form'}
                className={`filters_btn`}
                type={'button'}
                hasBorder={false}
                iconOnly={false}
                onClick={() => {
                  if (isMobile) {
                    toggleDrawer();
                  }
                  setEditMenu(prev => !prev)
                }}
              >{createSVG('filter')} <span>{`${getDictionaryText('FiltersText')}`}</span>
              </ButtonMUI>
            </Box>
          </Box>
          {showInterestsMobDrawer && renderInterestsMobDrawer()}
        </>
      }

      <Grid
        item
        className={`${classes.filterWrappeer} js-filter_wrapper`}
        data-locator={FILTER_CONTAINER}
      >
        {isADeventFilters && <ADListing props={props} adCalendarItems={adCalendarItems || []} selectedInitialValue={adCalendarTopBannerInitialValue} renderEventHandler={renderEventHandler} shouldResetFilter={shouldResetFilter} />}
        <Hidden lgUp implementation="css">
          {!isGlobalSearchTemplate && contentType !== ATTRIBUTE_TYPE && filtersDataLength > 1 ?
            <div className={`${classes.viewAllMobileBtn} ${isADeventFilters ? 'hide' : ''}`}>
              <ButtonMUI
                buttonType={'form'}
                type={'button'}
                onClick={() => fetchAllResults(contentType, language)}
                hasBorder={false}
                field={{ value: { text: renderText({ value: `${getDictionaryText('listingViewAllText')} ${filtersDataLength}` }, 'body2Bold', '') } }}
                iconOnly={false}
                classes={{ endIcon: classes.viewAllBtnEndIcon }}
              />
            </div>
            : ''}
          {!isADeventFilters ?
            (<div
              className={classes.togglefilterButton}
              data-locator={FILTER_LIST_MOBILE_SECTION}
            >
              <ButtonMUI
                buttonType={'form'}
                type={'button'}
                onClick={() => toggleDrawer()}
                hasBorder={false}
                isStartIcon
                field={{ value: { text: filtersText && filtersText.value } }}
                iconName={'FilterListIcon'}
                // This comments for Event page
                className={contentType === EVENT_TYPE ? classes.eventBtnColor : ''}
              />
            </div>)
            : null}
          <SwipeableDrawer
            open={shouldOpenDrawer}
            onOpen={() => { }}
            onClose={() => {
              toggleDrawer()
              isADeventFilters && removeAdFiltersSelectedWithoutSubmit();
            }}
            className={isADeventFilters ? classes.AdMobileDrawer : ''}
          >
            {filterDOM(isMobile && isADeventFilters ? true : false)}
          </SwipeableDrawer>
        </Hidden>
        {isADeventFilters ?
          (
            <>
              {!isADeventFilters && !isGlobalSearchTemplate && contentType !== ATTRIBUTE_TYPE && parentComponentName !== 'FavoriteSubLayout' ? <div className={classes.desktopViewAllSection}>
                <div className={classes.listingText}>
                  {renderText({ value: filtersDataLength }, 'h4', '')}
                  {renderText({ value: getDictionaryText('listings') }, 'body1', '')}
                </div>
                <ButtonMUI
                  buttonType={'form'}
                  type={'button'}
                  onClick={() => fetchAllResults(contentType, language)}
                  hasBorder={false}
                  field={{ value: { text: renderText({ value: getDictionaryText('viewThemAll') }, 'body2Bold', '') } }}
                  iconOnly={false}
                  // This comments for Event page
                  className={contentType === EVENT_TYPE ? classes.eventBtnColor : ''}
                />
              </div> : ''}
              {filterDOM()}
            </>
          )
          :
          (
            <Hidden mdDown implementation="css">
              {!isGlobalSearchTemplate && contentType !== ATTRIBUTE_TYPE && parentComponentName !== 'FavoriteSubLayout' ? <div className={classes.desktopViewAllSection}>
                <div className={classes.listingText}>
                  {renderText({ value: filtersDataLength }, 'h4', '')}
                  {renderText({ value: getDictionaryText('listings') }, 'body1', '')}
                </div>
                <ButtonMUI
                  buttonType={'form'}
                  type={'button'}
                  onClick={() => fetchAllResults(contentType, language)}
                  hasBorder={false}
                  field={{ value: { text: renderText({ value: getDictionaryText('viewThemAll') }, 'body2Bold', '') } }}
                  iconOnly={false}
                  // This comments for Event page
                  className={contentType === EVENT_TYPE ? classes.eventBtnColor : ''}
                />
              </div> : ''}
              {filterDOM()}
            </Hidden>
          )
        }

      </Grid>
    </>
  );
};

export const mapDispatchToProps = dispatch => {
  return {
    getFiltersInfoData: params => dispatch(getFiltersInfoData(params)),
    getFiltersInfoSuccess: params => dispatch(getFiltersInfoSuccess(params)),
    updateFiltersData: params => dispatch(updateFiltersData(params)),
    updateSelectedFiltersData: params =>
      dispatch(updateSelectedFiltersData(params)),
    updateQueryFilterData: params => dispatch(updateQueryFilterData(params)),
    clearAllClicked: params => dispatch(clearAllClicked(params)),
    getFilterdInfoData: params => dispatch(getFilterdInfoData(params)),
    clearFilterData: params => dispatch(clearFilterData(params)),
    mobileFiltersUpdate: params => dispatch(mobileFiltersUpdate(params)),
    clearFilteredData: params => dispatch(clearFilteredData(params)),
    updateMultipleFiltersData: params =>
      dispatch(updateMultipleFiltersData(params)),
    updateFiltersForAdCalendarData: params => dispatch(updateFiltersForAdCalendarData(params)),
    shouldResetFiltersForAdCalendarData: params => dispatch(shouldResetFiltersForAdCalendarData(params)),
    getFilterdInfoSuccess: params => dispatch(getFilterdInfoSuccess(params))
  };
};

export const mapStateToProps = createStructuredSelector({
  filtersData: filtersData,
  selectedFiltersData: selectedFiltersData,
  searchTermData: searchTermData,
  clearAllClickedData: clearAllClickedData,
});

export default withErrorBoundary(
  withSitecoreContext()(
    withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(Filters))
  )
);

export { Filters as FiltersTest };